import { render } from "./SearchCustomers.vue?vue&type=template&id=88ed00fc&scoped=true"
import script from "./SearchCustomers.vue?vue&type=script&lang=ts"
export * from "./SearchCustomers.vue?vue&type=script&lang=ts"

import "./SearchCustomers.vue?vue&type=style&index=0&id=88ed00fc&lang=scss&scoped=true"
import "./SearchCustomers.vue?vue&type=style&index=1&id=88ed00fc&lang=scss"
script.render = render
script.__scopeId = "data-v-88ed00fc"

export default script